<template>
  <v-row class="pa-2">
    <!-- COLUMNA IZQUIERDA: CONFIGURACIÓN DE FECHAS/HORAS -->
    <v-col cols="12" md="4">
      <v-card class="pgs-modern-card d-flex flex-column h-100" elevation="0">
        <div class="px-5 pt-5 pb-2 border-bottom">
          <ModuleHeader>Selecciona rango de bloqueo</ModuleHeader>
        </div>
        
        <v-card-text class="flex-grow-1 pt-4">
          <div class="mb-4 custom-datepicker">
            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Fecha inicial</div>
            <Datepicker
              @selected="selectStartDate"
              :value="startDate.format('MM/DD/YYYY')"
              input-class="modern-input"
            ></Datepicker>
          </div>
          
          <div class="mb-6 custom-datepicker">
            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Fecha final</div>
            <Datepicker
              @selected="selectEndDate"
              :value="endDate.format('MM/DD/YYYY')"
              input-class="modern-input"
            ></Datepicker>
          </div>

          <v-divider class="mb-5"></v-divider>

          <v-row>
            <v-col cols="6">
              <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Hora Inicial</div>
              <div class="modern-timepicker">
                <datetime
                  type="time"
                  input-id="iniTime"
                  :min-datetime="minDate"
                  :max-datetime="maxDate"
                  v-model="HoraInicial"
                  :auto="false"
                  :format="{ hour: 'numeric', minute: '2-digit' }"
                  :minute-step="10"
                  input-class="modern-input"
                >
                </datetime>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Hora Final</div>
              <div class="modern-timepicker">
                <datetime
                  type="time"
                  input-id="endTime"
                  v-model="HoraFinal"
                  :minute-step="10"
                  :auto="false"
                  :min-datetime="initialHour"
                  :max-datetime="maxDate"
                  input-class="modern-input"
                ></datetime>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- COLUMNA DERECHA: DEPARTAMENTO Y APLICAR -->
    <v-col cols="12" md="8">
      <v-card class="pgs-modern-card d-flex flex-column h-100" elevation="0">
        <div class="px-5 pt-5 pb-2 border-bottom">
          <ModuleHeader>Departamento y Acción</ModuleHeader>
        </div>
        
        <v-card-text>
          <div class="mb-6">
            <selectDepartment></selectDepartment>
          </div>

          <v-divider class="mb-5"></v-divider>

          <ModuleHeader>Detalles del Bloqueo</ModuleHeader>
          
          <v-alert
            v-if="HoraInicial == '' || HoraFinal == ''"
            outlined
            color="orange darken-2"
            icon="mdi-clock-alert-outline"
            class="rounded-lg mt-4"
          >
            Seleccione un rango de horas en el panel izquierdo para continuar.
          </v-alert>

          <div v-if="HoraInicial != '' && HoraFinal != ''" class="mt-4">
            <v-card outlined class="bg-blue-lighten-5 blue--text text--darken-3 px-4 py-3 mb-6 rounded-lg d-flex align-center">
              <v-icon color="blue darken-2" class="mr-3" large>mdi-clock-time-four-outline</v-icon>
              <div>
                <div class="text-caption font-weight-bold text-uppercase">Horario Seleccionado</div>
                <div class="text-h5 font-weight-bold">
                  {{ Hour.inicial.format("HH:mm") }} - {{ Hour.final.format("HH:mm") }}
                </div>
              </div>
            </v-card>
            
            <v-row>
              <v-col cols="12" md="6">
                <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Motivo de Bloqueo</div>
                <v-text-field 
                  outlined 
                  dense
                  v-model="Motivo"
                  hide-details
                  class="rounded-lg"
                  placeholder="Ej. Torneo, Mantenimiento..."
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Estatus</div>
                <v-autocomplete
                  v-model="status"
                  :items="[
                      { value: '1', text: 'Disponibles' },
                      { value: '2', text: 'No Disponibles' },
                    ]"
                  outlined
                  dense
                  hide-details
                  class="rounded-lg"
                ></v-autocomplete>
              </v-col>
            </v-row>
            
            <div class="mt-8 text-right">
              <v-btn @click="sendData()" color="primary" elevation="0" large class="text-none font-weight-bold rounded-lg px-8">
                <v-icon left>mdi-check-circle</v-icon> Aplicar Bloqueo
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
/* Scoped o estilos globales para los datepickers/inputs en esta vista */
.pgs-modern-card {
  background-color: white;
  border-radius: 16px !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
}
.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}
.bg-blue-lighten-5 {
  background-color: #eff6ff !important;
}

/* Sobreescribiendo estilos feos de input que existian */
.modern-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8fafc;
  color: #334155;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.modern-input:focus {
  border-color: var(--v-primary-base, #1976D2);
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
  background-color: white;
}
</style>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "configTimes",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      Motivo: "BLOQUEADO",
      startDate: moment(),
      endDate: moment(),
      status: "",
      HoraInicial: "",
      HoraFinal: "",
      minDate: "06:00",
      maxDate: "23:01",
      MainDepartamento: "",
    };
  },
  methods: {
    init() {},
    selectStartDate(arg) {
      this.startDate = moment(arg);
      if (this.endDate.isBefore(this.startDate)) {
        this.endDate = moment(arg);
      }
    },
    selectEndDate(arg) {
      this.endDate = moment(arg);
    },
    sendData() {
      if (this.status != "") {
        let diffDays = this.endDate.diff(this.startDate, 'days');
        if (diffDays < 0) {
          this.$swal("Error", "La fecha final no puede ser menor a la fecha inicial", "error");
          return;
        }
        if (diffDays > 31) {
          this.$swal("Error", "El rango de fechas no puede ser mayor a 1 mes (31 días)", "error");
          return;
        }

        this.$swal({
          title: "Atención",
          html: `
            <div style="text-align: left;">
              <p>Estás a punto de modificar el Estatus de las horas seleccionadas para el rango del <b>${this.startDate.format("DD/MM/YYYY")}</b> al <b>${this.endDate.format("DD/MM/YYYY")}</b> (${diffDays + 1} días).</p>
              <div id="swal-progress-container" style="display:none; margin-top: 15px;">
                <p><b>Progreso de ejecución:</b></p>
                <div style="background-color: #eee; border-radius: 4px; overflow: hidden; height: 20px; position: relative;">
                  <div id="swal-progress-bar" style="background-color: #4caf50; height: 100%; width: 0%; transition: width 0.2s;"></div>
                </div>
                <p id="swal-progress-text" class="mt-2 text-center" style="font-size: 14px;">Preparando...</p>
              </div>
            </div>
          `,
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            let currentDate = moment(this.startDate);
            let stopDate = moment(this.endDate);
            let datesArray = [];
            while (currentDate <= stopDate) {
              datesArray.push(currentDate.format("YYYY-MM-DD"));
              currentDate.add(1, 'days');
            }

            const container = document.getElementById('swal-progress-container');
            if (container) {
              container.style.display = 'block';
            }

            const progressBar = document.getElementById('swal-progress-bar');
            const progressText = document.getElementById('swal-progress-text');

            let errors = [];
            for (let i = 0; i < datesArray.length; i++) {
              let d = datesArray[i];
              let percent = Math.round((i / datesArray.length) * 100);

              if (progressBar) progressBar.style.width = `${percent}%`;
              if (progressText) progressText.textContent = `Procesando: ${d} (${i + 1}/${datesArray.length})`;

              let data = {
                date: d,
                times: [
                  [
                    this.Hour.inicial.format("HH:mm:ss"),
                    this.Hour.final.format("HH:mm:ss"),
                  ],
                ],
                block: this.status == 1 ? false : true,
                Todos: true,
                motivo: this.Motivo,
                Departamento: this.MainDepartamento
              };

              try {
                let result = await this.$store.getters.getFirebaseApp.fba.call("RVA-TeeSheet-bloquearTeetime", data);
                if (!result || !result.data || !result.data.ok) {
                  errors.push({ date: d, error: result?.data?.error || "Error de red o de servidor" });
                }
              } catch (error) {
                errors.push({ date: d, error: error.message || error });
              }
            }

            if (progressBar) progressBar.style.width = '100%';
            if (progressText) progressText.textContent = 'Completado';

            return { ok: errors.length === 0, errors: errors, total: datesArray.length };
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.ok) {
              this.$swal("Guardado", "Las horas fueron modificadas para todo el rango", "success");
              this.$emit("changeIndex");
            } else {
              let errorMsg = result.value.errors.map(e => `${e.date}: ${e.error}`).join("<br>");
              this.$swal({
                title: "Error al procesar algunas fechas",
                html: `No se pudieron guardar todas las fechas:<br><br><div style="text-align: left; max-height: 150px; overflow-y: auto; font-size:12px;">${errorMsg}</div>`,
                icon: "error"
              });
              this.$emit("changeIndex");
            }
          }
        });
      } else {
        this.$swal("¡¡Seleccione un Estatus", "", "error");
      }
    },
  },
  computed: {
    initialHour() {
      if (this.HoraInicial === "") {
        return this.minDate;
      } else {
        let hour = new moment(this.HoraInicial);
        //hour.add(10, 'minutes')
        return hour.format("HH:mm");
      }
    },
    Hour() {
      let ini = moment(this.HoraInicial);
      let fini = moment(this.HoraFinal);

      return { inicial: ini, final: fini };
    },
  },
  watch: {
    HoraInicial: function () {
      this.HoraFinal = "";
    },
  },
  mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
  created() {},
};
</script>

<style >
  .input input{
    border-bottom: 1px solid black;
    width: 100%;
  }
</style>